import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRippleComponent } from './simple-icons-ripple.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRippleComponent ],
    exports:      [ SimpleIconsRippleComponent ],
    bootstrap:    []
})
export class SimpleIconsRippleModule {}
